import React, { useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import codebaseService from "../../services/codebaseService";

export default function PopupGfg({ open, closePopup, refreshCodebases }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [framework, setFramework] = useState("tensorflow");
  const userId = sessionStorage.getItem("userId");
  const sessionToken = sessionStorage.getItem("session_token");
  const navigate = useNavigate();
  const [isSupervised, setIsSupervised] = useState(true);

  const AddCodebase = async () => {
    if (!title.trim() || !description.trim()) {
      Swal.fire("Error!", "Both fields are required!", "error");
      return;
    }

    const modelType = isSupervised ? "supervised" : "unsupervised";

    try {
      console.log("Sending request to add codebase:", {
        userId,
        sessionToken,
        title,
        description,
        modelType,
        framework,
      });

      // FIXED: Pass individual parameters instead of object
      const responseData = await codebaseService.addCodebase(
        userId,
        sessionToken,
        title,
        description,
        modelType,
        framework,
      );

      console.log("Full response from add_codebase:", responseData);

      // Ensure backend returns `codebaseId`
      if (!responseData.codebaseId) {
        console.error(
          "❌ Backend did not return codebaseId! Full response:",
          responseData,
        );
        throw new Error("No codebaseId returned from backend");
      }

      const createdCodebaseId = responseData.codebaseId;

      sessionStorage.setItem("mode", modelType);
      sessionStorage.setItem("framework", framework);

      Swal.fire("Success!", "Codebase added successfully!", "success").then(
        () => {
          closePopup();
          refreshCodebases();
          navigate(`/codebase/edit/${createdCodebaseId}/data-preparation`, {
            state: { mode: modelType, framework: framework },
          });
        },
      );
    } catch (error) {
      console.error("❌ Error adding codebase:", error);

      let errorMessage = "Failed to add codebase. Please try again.";
      if (error.response) {
        errorMessage = error.response.data.message || errorMessage;
      }

      Swal.fire("Error!", errorMessage, "error");
    }
  };

  return (
    <Popup open={open} closeOnDocumentClick onClose={closePopup} modal nested>
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f9f9f9",
          borderRadius: "10px",
        }}
      >
        <h1
          style={{ fontSize: "2em", fontWeight: "bold", marginBottom: "20px" }}
        >
          Add New Codebase
        </h1>
        <label style={{ display: "block", marginBottom: "10px" }}>
          Title:{" "}
        </label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
        <label style={{ display: "block", marginBottom: "10px" }}>
          Description:{" "}
        </label>
        <textarea
          rows="4"
          cols="50"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "5px",
            border: "1px solid #ccc",
          }}
        />
        <div style={{ marginBottom: "20px" }}>
          <label style={{ marginRight: "10px" }}>Learning Type:</label>
          <label>
            <input
              type="radio"
              checked={isSupervised}
              onChange={() => setIsSupervised(true)}
            />{" "}
            Supervised
          </label>
          <label style={{ marginLeft: "20px" }}>
            <input
              type="radio"
              checked={!isSupervised}
              onChange={() => setIsSupervised(false)}
            />{" "}
            Unsupervised
          </label>
        </div>

        {/* Framework Selector */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "10px" }}>
            Framework:
          </label>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              onClick={() => setFramework("tensorflow")}
              style={{
                padding: "10px 20px",
                backgroundColor:
                  framework === "tensorflow" ? "#f97316" : "#e5e7eb",
                color: framework === "tensorflow" ? "#fff" : "#374151",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "600",
                transition: "all 0.2s",
              }}
            >
              TensorFlow
            </button>
            <button
              type="button"
              onClick={() => setFramework("pytorch")}
              style={{
                padding: "10px 20px",
                backgroundColor:
                  framework === "pytorch" ? "#ef4444" : "#e5e7eb",
                color: framework === "pytorch" ? "#fff" : "#374151",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontWeight: "600",
                transition: "all 0.2s",
              }}
            >
              PyTorch
            </button>
          </div>
        </div>

        <button
          onClick={AddCodebase}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Submit
        </button>
      </div>
    </Popup>
  );
}
